import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { ActivityLogState } from "./types";
import { RootState } from "../types";

export const state: ActivityLogState = {
	emptyState: true
};

const namespaced: boolean = true;

export const activityLog: Module<ActivityLogState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
